// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"560":"fa464122","884":"6275adb1"}[chunkId] + ".chunk.js");